<wiz-vgroup padding="10px" width="100%" height="100%" class="section-container">

      <wiz-hgroup width="100%">
        <wiz-label
        [wizLabel]="'$.widget.configure.data-bank.$'"
        width="100%"
        class="smallTitleLabel"
        ></wiz-label>
        <wiz-icon (click)="hide()" style="cursor: pointer">close</wiz-icon>
      </wiz-hgroup>
      
      <wiz-list
        #ddSteps
        class="shadowed"
        width="100%"
        height="100%"
        [wizLabel]="'$.vision.steps.$'"
        [wizLabelField]="'levelAndLabel'"
        [wizDataProvider]="stepDS">
      </wiz-list>

      <multi-display code="ddMasters" #ddMasters width="100%" height="100%" [config]="masterConfig">
        <wiz-hgroup target="title" width="100%">     
          <wiz-label [wizLabel]="'$.widget.master.$'" class="smallTitleLabel" width="100%"></wiz-label>
        </wiz-hgroup>
      </multi-display>


  <wiz-hgroup width="100%" horizontalAlign="end">
    <wiz-button wizLabel="$.common.validate.$" (wizClick)="save()" [wizDisabled]="!validable" width="200px"></wiz-button>
  </wiz-hgroup>
</wiz-vgroup>
